import { render, staticRenderFns } from "./ScholarMain.vue?vue&type=template&id=915affa4&lang=pug&"
import script from "./ScholarMain.vue?vue&type=script&lang=js&"
export * from "./ScholarMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports